import { ResponseType } from 'business/models/Models';
import MiscService from 'business/services/MiscService';
import { useModalHandlers } from 'components/modal';
import { useCallback } from 'react';

const miscService = new MiscService();
export const emailErrorMessage =
  'Failed to send email. Please check your SMTP configuration and try again. If the issue persists, contact support@formulatrix.com for assistance.';

const useSendTestEmail = () => {
  const { hideModal, showLoadingModal, showModal } = useModalHandlers();

  const sendTestEmail = useCallback(async () => {
    showLoadingModal('Sending Email');
    const response = await miscService.sendTestEmail();
    if (!response) {
      return;
    }

    const { responseType, message } = response;
    const isInfo = responseType === ResponseType.Info;

    showModal({
      heading: ResponseType[responseType],
      body: isInfo ? message : emailErrorMessage,
      showButtons: true,
      okButtonText: 'OK',
      onOk: hideModal,
      isOkOnly: true,
    });
  }, [showLoadingModal, hideModal, showModal]);

  return sendTestEmail;
};

export default useSendTestEmail;
